<div class="dsgnr-wrap">
  <main class="dsgnr-body" role="main">
    <div class="container single-content-layout-layout-block">
      <div class="row justify-content-center">
        <div class="column-block col-12 col-md-10 col-lg-8">
          <div class="watersharing-blocks">
            <div class="watersharing-card-wrap">
              <div class="watersharing-card-inner">
                <div class="watersharing-card-header">
                  <i class="fa-regular fa-map"></i>
                  <h1 class="h4 watersharing-card-title">
                    {{ type === 'Have' ? 'I Have Water' : 'I Need Water' }}
                  </h1>
                </div>
                <div class="watersharing-card-body">
                  <form [formGroup]="waterForm" (ngSubmit)="onSubmit()" class="watersharing-form">

                    <!-- Primary Information -->
                    <div class="accordion" id="primary-information">
                      <div class="accordion-item">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-primary-information">
                          <strong>Primary Information</strong>
                        </button>
                        <div id="collapse-primary-information" class="accordion-collapse collapse show">
                          <div class="accordion-body">
                            <div class="watersharing-row">
                              <label>CTP (Wellpad, Pipeline Riser, etc.)</label>
                              <select formControlName="well_pad" class="form-select" (change)="loadSiteInfo()">
                                <option value="newPad">Create A New Site</option>
                                <option *ngFor="let sn of sites" [value]="sn.name">{{sn.name}}</option>
                              </select>
                            </div>
                            <div class="watersharing-row watersharing-input">
                              <label>CTP Identifier<span class="required">*</span></label>
                              <input type="text" formControlName="well_name" class="form-control" placeholder="Site Name" required>
                            </div>
                            <div class="watersharing-row">
                              <label>CTP Geospatial Coordinates</label>
                              <div class="two-col">
                                <div class="watersharing-input-col">
                                  <input type="number" formControlName="latitude" placeholder="Latitude" required>
                                </div>
                                <div class="watersharing-input-col">
                                  <input type="number" formControlName="longitude" placeholder="Longitude" required>
                                </div>

                              </div>
                            </div>
                            <div class="watersharing-row">
                              <label>I Can Accept Transport</label>
                              <div class="checkbox-row">
                                <div class="checkbox-item">
                                  <input type="checkbox" formControlName="can_accept_trucks" id="can_accept_trucks">
                                  <label for="can_accept_trucks">I can accept trucks on-site</label>
                                </div>
                                <div class="checkbox-item">
                                  <input type="checkbox" formControlName="can_accept_layflats" id="can_accept_layflats">
                                  <label for="can_accept_layflats">I can accept layflat pipelines on-site</label>
                                </div>
                              </div>
                            </div>
                            <div class="watersharing-row">
                              <label>Date Range</label>
                              <div class="two-col date-range">
                                <input type="date" formControlName="start_date" placeholder="Start Date" required>
                                <span class="date-separator"></span>
                                <input type="date" formControlName="end_date" placeholder="End Date" required>
                              </div>
                            </div>
                            <div class="watersharing-row">
                              <label>Water Available Rate (bpd)</label>
                              <div class="two-row">
                                <input type="number" formControlName="rate_bpd" placeholder="Rate in barrels per day" required min="0">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Bidding Information (Trading Only) -->
                    <div *ngIf="context === 'Trade'" class="accordion" id="bidding-information">
                      <div class="accordion-item">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-bidding-information">
                          <strong>Bidding Information</strong>
                        </button>
                        <div id="collapse-bidding-information" class="accordion-collapse collapse">
                          <div class="accordion-body">

                            <!-- Bid Type -->
                            <div class="watersharing-row">
                              <label for="bid_type" class="watersharing-form-label"><p>Bid Type<span class="required">*</span></p></label>
                              <div class="watersharing-input-col">
                                <div class="custom-meta-field">
                                  <div class="meta-box-radio">
                                    <div class="meta-radio-select">
                                      <input type="radio" formControlName="bid_type" name="bid_type" id="willing_to_pay" value="Willing to pay" class="radio-button">
                                      <label for="willing_to_pay">Willing To Pay</label>
                                    </div>
                                    <div class="meta-radio-select">
                                      <input type="radio" formControlName="bid_type" name="bid_type" id="want_to_be_paid" value="Want to be paid" class="radio-button">
                                      <label for="want_to_be_paid">Want To Be Paid</label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- Bid Info -->
                            <div class="watersharing-row">
                              <label for="bid_info" class="watersharing-form-label"><p>Bid<span class="required">*</span></p></label>
                              <div class="watersharing-input-col">
                                <div class="watersharing-row no-margin-bottom two-col">
                                  <div class="watersharing-input-col two-col">
                                    <div class="watersharing-input-col no-label">
                                      <input type="number" formControlName="bid_amount" class="form-control trade_supply-bid_amount" id="bid_amount" placeholder="Bid Amount" step=".01">
                                    </div>
                                  </div>
                                  <div class="watersharing-input-col two-col">
                                    <div class="watersharing-input-col no-label">
                                      <select formControlName="bid_units" id="bid_units" class="user-select trade_supply-bid_units">
                                        <option value="" selected hidden disabled>–Select–</option>
                                        <option value="USD/day">USD/day</option>
                                        <option value="USD/bbl.day">USD/bbl.day</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- Total Value -->
                            <div class="watersharing-row">
                              <label for="bid_total" class="watersharing-form-label"><p>Total Value</p></label>
                              <div class="watersharing-input-col">
                                <input type="text" class="form-control trade_supply-totalval" id="bid_total" placeholder="0" readonly [value]="calcBidTotal | number:'1.2-2'">
                              </div>
                            </div>

                            <!-- Barrel Value -->
                            <div class="watersharing-row">
                              <label for="bid_specific_total" class="watersharing-form-label"><p>Barrel Value</p></label>
                              <div class="watersharing-input-col">
                                <input type="text" class="form-control trade_supply-specval" id="bid_specific_total" placeholder="0" readonly [value]="calcBidSpecificTotal | number:'1.2-2'">
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Transport -->
                    <div class="accordion" id="delivery">
                      <div class="accordion-item">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-delivery">
                          <strong>I Can Provide Transport (optional)</strong>
                        </button>

                        <div id="collapse-delivery" class="accordion-collapse collapse">
                          <!-- Trucks row -->
                          <div class="transport-row">
                            <div class="checkbox-col">
                              <input type="checkbox" id="trucksCheckbox" formControlName="trucksCheckbox">
                              <label for="trucksCheckbox">I Can Provide Trucks</label>
                            </div>
                            <div class="inputs-col">
                              <input type="number" formControlName="truck_transport_radius" placeholder="Range (mi)">
                              <input type="number" formControlName="truck_capacity" placeholder="Capacity (bbl)">
                            </div>
                          </div>

                          <!-- Layflats row -->
                          <div class="transport-row">
                            <div class="checkbox-col">
                              <input type="checkbox" id="layflatsCheckbox" formControlName="layflatsCheckbox">
                              <label for="layflatsCheckbox">I Can Provide Layflats</label>
                            </div>
                            <div class="inputs-col">
                              <input type="number" formControlName="layflats_transport_radius" placeholder="Range (mi)">
                              <input type="number" formControlName="layflats_capacity" placeholder="Capacity (bbl)">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Quality Requirements -->
                    <div class="accordion" id="quality-disclosures">
                      <div class="accordion-item">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-quality-disclosures">
                          <strong>Quality Requirements (optional)</strong>
                        </button>
                        <div id="collapse-quality-disclosures" class="accordion-collapse collapse">
                          <div class="accordion-intro-text">
                            Use this optional section to declare quality properties associated with your request; either quality associated with water you have or
                            requirements for water you need. You may populate some or all of the fields provided. Doing so can help refine the matches you receive but
                            is not required.
                          </div>
                          <div class="accordion-body">
                            <div class="quality-row" *ngFor="let field of qualityFields">
                              <!-- Label column -->
                              <div class="quality-label">
                                <label [for]="field + '_limit'">{{ field | titlecase }}</label>
                              </div>

                              <!-- Inputs column -->
                              <div class="quality-inputs">
                                <select [id]="field + '_limit'" [formControlName]="field + '_limit'">
                                  <option value="" disabled selected>–Select–</option>
                                  <option *ngFor="let option of comparisonOptions" [value]="option.value">{{ option.label }}</option>
                                </select>
                                <input type="number" [id]="field + '_measure_value'" [formControlName]="field + '_measure_value'" placeholder="Value (ppm)" min="0">
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    <button type="submit" class="watersharing-submit-button">
                      {{ isEditMode ? 'Save' : 'Submit' }}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
